/**
 * Optimistic-lock read — only the card's current `revisions`.
 * Use to resync persistence when opening an editor or after server-side bumps
 * outside `updateCard` (e.g. `createFilter(cardId)`).
 */
export const queryGetCardRevisions = `
	query getCardRevisions($cardId: ID!) {
		getItem {
			card(cardId: $cardId) {
				revisions
			}
		}
	}
`;
